import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';

export default function popclip_Box(props) {
  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);
  //link로그를
  const handleClick = (a,b,c,d) => {
    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    let conver_current_s= (parseInt(c));
    let conver_current_s2 = (parseInt(props.loc_idx));
    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: '클립', //모듈 아이디 없으면
        moduleTitle: '실시간 인기 랭킹', //모듈 제목 (Require)
        moduleSubTitle: '',
        moduleActive: 'C', //콘텐츠 선택 정보 Click: C, Hover: H
        moduleSeq: conver_current_s2, //페이지에서 해당 모듈의 위치
        moduleItemSeq: conver_current_s, //모듈 내에서 콘텐츠의 위치
        programId: b.pgm_id, //프로그램의 아이디 (추가)
        programTitle: b.pgm_nm, //프로그램의 제목 (추가)
        contentId: b.mda_id, //식별자
        contentTitle: b.content, //콘텐츠의 제목  (Require)
        contentNumber: '',
        contentType: 'C', //콘텐츠의 타입 (별도 표 참조)
      }
    });
  };

  return (

    <>
      {/* <!-- 실시간랭킹 -->*/}
      <div className="mainContents-typeWhite">
        <div className="contentsBlock_w">
          <div className="moduleTitleline_w">
            <h2 className="moduleTitleline-Title">{props.data.list_title}</h2>
            <a href={props.data.alllink_url} className="moduleTitleline-linkMore" style={{ visibility: (props.data.alllink_yn == 'Y' && props.data.alllink_url != '' && props.data.alllink_url != null) ? 'visible' : 'hidden' }}>{props.data.alllink_title}</a>
          </div>
          <div className={"listModule_w_ranking ranking" + props.loc_idx}>
            <div className="listModuleSlider listScrollSlider">{/* <!-- mySwiper 클래스 추가시 동작 -->*/}
              {/* <!-- 리스트 -->*/}
              <div className="SliderContent swiper-wrapper">
                {
                  props.data.contents.map((item, index) => {
                    return (
                      <div className="listModuleItem swiper-slide">
                        <div className="moduleBoxWrap_ranking">
                          <Link href={item.link_url} >
                            <a  onClick={(e) => handleClick(e, item,index,'인기')}  target={item.link_new_yn == 'Y' ? '_blank' : ''} className="mb_link">
                              <div className="mb_image_w">
                                <span className="mb_label_time">{item.plytm}</span>
                                <div className="mb_image_inner">
                                  <img src={item.img_url} className="mb_image" alt={item.img_attr} />
                                </div>
                              </div>
                              <div className="mb_number_w">
                                <span className={`iconSvg_${item.rank}`}><i className="hide">1</i></span>
                              </div>
                              <div className="mb_info_w">
                                <span className="mbif_title">{item.content}</span>
                                <span className="mbif_subinfo">{item.pgm_nm}</span>
                              </div>
                            </a>
                          </Link>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  );

}